import { render, staticRenderFns } from "./RankView.vue?vue&type=template&id=d2effac2&scoped=true"
import script from "./RankView.vue?vue&type=script&lang=js"
export * from "./RankView.vue?vue&type=script&lang=js"
import style0 from "./RankView.vue?vue&type=style&index=0&id=d2effac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2effac2",
  null
  
)

export default component.exports